import { BaseModel } from 'model/base.model';
export interface Refund extends BaseModel {
  code?: string,
  desc?: string,
  refundApplicationDetails?: any;
}

export const defaultRefund: Readonly<Refund> = {
};